import KeyboardArrowDownIcon from '@material-design-icons/svg/filled/keyboard_arrow_down.svg?react';
import ViewColumnIcon from '@material-design-icons/svg/filled/view_column.svg?react';
import {
  type ColumnVisibilityState,
  columnVisibilityOptions,
  type HubspotColumnKey,
} from '../../../lib/hubspot-management/columnVisibility';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../ui/dropdown-menu';

interface HubspotColumnVisibilityMenuProps {
  columnVisibility: ColumnVisibilityState;
  onColumnVisibilityChange: (key: HubspotColumnKey, checked: boolean) => void;
  triggerClassName: string;
}

export function HubspotColumnVisibilityMenu({
  columnVisibility,
  onColumnVisibilityChange,
  triggerClassName,
}: HubspotColumnVisibilityMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className={triggerClassName} aria-label="Columns">
          <ViewColumnIcon className="size-4 fill-current text-neutral-400" />
          <span className="hidden lg:inline">Columns</span>
          <KeyboardArrowDownIcon className="size-4 fill-current text-neutral-500" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={6}
        className="w-56 rounded-lg border border-neutral-700 bg-neutral-900 p-2 text-white"
      >
        <DropdownMenuLabel className="px-2 py-1 text-xs uppercase tracking-wide text-neutral-500">
          Columns
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-neutral-700" />
        {columnVisibilityOptions.map((option) => (
          <DropdownMenuCheckboxItem
            key={option.key}
            checked={columnVisibility[option.key]}
            onCheckedChange={(checked) =>
              onColumnVisibilityChange(option.key, Boolean(checked))
            }
            disabled={!option.canHide}
            className="cursor-pointer rounded text-sm text-neutral-200 focus:bg-neutral-800 focus:text-white data-[disabled]:cursor-not-allowed data-[disabled]:opacity-40"
          >
            {option.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
